import styled from 'styled-components'
import { device } from '../Breakpoints'
import { colors } from '../Colors'

const Container = styled.section`
  background: ${colors.lilasGradiente};
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 190px;
  text-align: center;
  color: white;
  fieldset {
    border: none;
    display: inline;
    margin: 0;
    padding: 0;
    position: relative;
    margin: 25px 15px 0;
    span {
      color: red;
      position: absolute;
      bottom: -30px;
      left: 0;
      font-size: 17px;
    }
  }
  input {
    height: 30px;
    width: 330px;
    padding-left: 10px;
    font-family: 'Santral', Arial, Helvetica, sans-serif;
    border: none;
    @media ${device.tablet} {
      padding: 5px;
      margin: 5px 0 5px 4%;
      display: block;
      text-align: center;
      width: 90%;
    }
  }

  h3 {
    font-size: 1.5em;
    font-weight: normal;
    margin: 0;
    padding-top: 30px;

    @media ${device.tablet} {
      font-size: 1.5em;
      padding-top: 15px;
    }

    @media ${device.mobileL} {
      font-size: 0.8em;
    }
  }

  @media ${device.tablet} {
    height: 240px;
    text-align: center;
    padding: 0;
    margin: 0;
  }
`

export default Container
